module.exports = __webpack_public_path__ + "img/googlepay.84d16126.png";